<template>
    <div>
        <div class="text-center" v-if="!readonly" style="margin-bottom: 15px">
            <button type="button" class="btn btn-default" @click="showAddModal">
                <i class="fa fa-plus" /> Tambah Journey
            </button>
        </div>
        <div class="history-mobile">
            <div
                v-for="(milestone, index) in resources"
                class="row history-item"
                :key="index"
            >
                <div class="col-xs-1">
                    <div class="bullet"></div>
                    <div class="line matchHeight"></div>
                </div>
                <div class="col-xs-11 matchHeight">
                    <div class="thumbnail" style="position: relative">
                        <button
                            v-if="!readonly"
                            type="button"
                            class="btn btn-link"
                            @click.prevent="handleDelete(index)"
                            title="Hapus"
                            style="
                                position: absolute;
                                top: 15px;
                                right: 15px;
                                padding: 0;
                            "
                        >
                            <i class="fa fa-trash" />
                        </button>
                        <div class="caption" style="padding: 15px">
                            <div class="media">
                                <div class="media-body">
                                    <h4
                                        style="
                                            margin-bottom: 5px;
                                            margin-top: 0;
                                            font-weight: bold;
                                        "
                                    >
                                        {{ milestone.created_at | datetime }}
                                    </h4>
                                    <span>
                                        {{ milestone.label }}
                                    </span>
                                    <span
                                        v-if="Boolean(milestone.description)"
                                        class="help-block"
                                        style="margin: 0"
                                    >
                                        {{ milestone.description }}
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <member-milestone-create-modal
            id="add-milestone-modal"
            @submit="handleAdd"
        />
    </div>
</template>

<script>
import XFormGroup from "../../components/XFormGroup.vue";
import { deletePrompt, getLoggedUser } from "../../helpers";
import MemberMilestoneCreateModal from "./MemberMilestoneCreateModal.vue";

export default {
    components: { XFormGroup, MemberMilestoneCreateModal },
    data() {
        return {
            resources: [...this.value],
        };
    },
    methods: {
        handleAdd(resource) {
            this.resources.push({
                ...resource,
                description: `Ditambahkan secara manual oleh ${
                    getLoggedUser().name
                }`,
            });
            this.resources.sort((a, b) => {
                return new Date(a.created_at) - new Date(b.created_at);
            });
            $(".matchHeight").matchHeight();
        },
        handleDelete(index) {
            return deletePrompt({
                title: "Hapus Journey",
                text: "Apakah Anda yakin ingin menghapus journey ini?",
                onConfirm: () => {
                    this.resources.splice(index, 1);
                    $(".matchHeight").matchHeight();
                },
            });
        },
        showAddModal() {
            $(`#add-milestone-modal`).modal("show");
        },
    },
    props: {
        readonly: {
            type: Boolean,
            default: false,
        },
        value: {
            type: Array,
            default: () => [],
        },
    },
    watch: {
        resources: {
            handler(newValue) {
                this.$emit("input", newValue);
            },
            deep: true,
        },
        value: {
            handler(newValue) {
                const internalJson = JSON.stringify(this.resources);
                const newValueJson = JSON.stringify(newValue);
                if (internalJson !== newValueJson)
                    this.resources = [...newValue];
            },
            deep: true,
            immediate: true,
        },
    },
};
</script>
